export {default as withStatusBar} from './withStatusBar';
